export function debug(...args: Parameters<typeof console.debug>) {
  // eslint-disable-next-line no-console
  console.debug(...args)
}

export function info(...args: Parameters<typeof console.info>) {
  // eslint-disable-next-line no-console
  console.info(...args)
}

export function warn(...args: Parameters<typeof console.warn>) {
  // eslint-disable-next-line no-console
  console.warn(...args)
}

export function error(...args: Parameters<typeof console.error>) {
  // eslint-disable-next-line no-console
  console.error(...args)
}

export const logger = {
  debug,
  info,
  warn,
  error,
} as const
